import React from 'react';
import styled from 'styled-components';

import Tooltip from '../../Tooltip';
import { ReactComponent as LinkIcon } from '../link.svg';

const EntityButton = styled.div`
  display: flex;
  padding: 3px;
  border-radius: 2px;
  border: 1px solid transparent;
  cursor: pointer;

  &:hover {
    border: 1px solid var(--color-grey-5);
    background-color: var(--color-bg-primary);
  }
`;

const LinkButton = ({
  onClick,
  tooltip,
}: {
  onClick?: () => void;
  tooltip: string;
}) => {
  return (
    <Tooltip content={tooltip}>
      <EntityButton onClick={onClick}>
        <LinkIcon />
      </EntityButton>
    </Tooltip>
  );
};

export default LinkButton;
